import { render, staticRenderFns } from "./advance-fee-pension.vue?vue&type=template&id=5c35b732"
import script from "./advance-fee-pension.vue?vue&type=script&lang=js"
export * from "./advance-fee-pension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports